<!--
 * @Author: your name
 * @Date: 2020-12-29 16:05:36
 * @LastEditTime: 2021-01-09 10:34:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /java-pc/src/views/home/Home.vue
-->
<template>
  <NavTopBar />
  <SldHomeTopSearch />
  <!-- <NavCatHeader /> -->
  <div class="bottom_line"></div>
  <router-view v-if="isRouterAlive"></router-view>
  <FooterService />
  <FooterLink />
</template>

<script>
import NavTopBar from '../../components/NavTopBar'
import SldHomeTopSearch from '../../components/SldHomeTopSearch'
// import NavCatHeader from '../../components/NavCatHeader'
import FooterService from '../../components/FooterService'
import FooterLink from '../../components/FooterLink'
export default {
  name: 'Home',
  components: {
    NavTopBar,
    SldHomeTopSearch,
    // NavCatHeader,
    FooterService,
    FooterLink
  },
  setup () {
    const isRouterAlive = true
    return { isRouterAlive }
  }
}
</script>
<style>
.bottom_line {
  width: 100%;
  background-color: #00a2e8;
}
</style>
